import { useState, type SyntheticEvent } from "react";
import type { PasswordLoginInput, RegistrationInput } from "../domain/oidc";
import { Icon } from "./Icon";

type AuthMode = "login" | "register";

export function AuthScreen({
  busy,
  error,
  onFeishuLogin,
  onPasswordLogin,
  onRegister,
}: {
  readonly busy: boolean;
  readonly error: string | null;
  readonly onFeishuLogin: () => void;
  readonly onPasswordLogin: (input: PasswordLoginInput) => void;
  readonly onRegister: (input: RegistrationInput) => void;
}) {
  const [mode, setMode] = useState<AuthMode>("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function submit(event: SyntheticEvent<HTMLFormElement, SubmitEvent>): void {
    event.preventDefault();
    if (mode === "register") {
      onRegister({ name: name.trim(), email: email.trim(), password });
      return;
    }
    onPasswordLogin({ email: email.trim(), password });
  }

  return (
    <main className={`auth-page ${mode === "register" ? "register-mode" : ""}`}>
      <div className="auth-glow glow-one" />
      <div className="auth-glow glow-two" />
      <section className="auth-card">
        <div className="auth-brand-mark"><Icon name="chat" /></div>
        <div className="auth-lockup"><h1>Sonox IM</h1></div>
        <div className="auth-tabs" role="tablist" aria-label="账号操作">
          <button className={mode === "login" ? "active" : ""} type="button" role="tab"
            aria-selected={mode === "login"} disabled={busy} onClick={() => { setMode("login"); }}>
            登录
          </button>
          <button className={mode === "register" ? "active" : ""} type="button" role="tab"
            aria-selected={mode === "register"} disabled={busy} onClick={() => { setMode("register"); }}>
            注册
          </button>
        </div>
        {error === null ? null : <div className="auth-error" role="alert">{error}</div>}
        <form className="auth-form" aria-busy={busy} onSubmit={submit}>
          {mode === "register" ? (
            <label><span>昵称</span><input name="name" value={name} autoComplete="name" maxLength={64}
              required disabled={busy} placeholder="你的昵称"
              onChange={(event) => { setName(event.target.value); }} /></label>
          ) : null}
          <label><span>邮箱</span><input name="email" value={email} type="email" autoComplete="email"
            maxLength={254} required disabled={busy} placeholder="name@example.com"
            onChange={(event) => { setEmail(event.target.value); }} /></label>
          <label><span>密码</span><input name="password" value={password} type="password"
            autoComplete={mode === "register" ? "new-password" : "current-password"}
            minLength={8} maxLength={128} required disabled={busy}
            placeholder={mode === "register" ? "至少 8 个字符" : "输入密码"}
            onChange={(event) => { setPassword(event.target.value); }} /></label>
          <button className="primary auth-action" type="submit" disabled={busy}>
            {busy ? <span className="spinner" /> : null}
            {busy ? "请稍候…" : mode === "login" ? "登录" : "注册并登录"}
          </button>
        </form>
        <div className="auth-divider"><span>或</span></div>
        <button className="auth-sso-action" type="button" onClick={onFeishuLogin} disabled={busy}>
          使用飞书登录
        </button>
        <p className="auth-hint"><span aria-hidden="true" />账号凭据由 Sonox SSO 安全管理</p>
      </section>
      <footer>Sonox IM · Built on Cloudflare</footer>
    </main>
  );
}
